import { useEffect } from 'react';

const SITE_NAME = 'RT Equipment & Haulage';
const DEFAULT_OG_IMAGE = '/og-image.png';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

// No react-helmet-async in this app (small client-only SPA, no SSR) — this hook sets
// document.title + meta/OG tags directly on mount, restoring the previous values on unmount so
// nested/overlapping route changes don't leave a stale title behind.
export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    const fullTitle = title ? `${title} · ${SITE_NAME}` : SITE_NAME;
    const previousTitle = document.title;
    document.title = fullTitle;

    const desc = description ?? 'Move heavy equipment across Jamaica with one tap.';
    upsertMeta('name', 'description', desc);
    upsertMeta('property', 'og:title', fullTitle);
    upsertMeta('property', 'og:description', desc);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:image', DEFAULT_OG_IMAGE);

    return () => {
      document.title = previousTitle;
    };
  }, [title, description]);
}
